import React from 'react';
import { observer,inject } from 'mobx-react';
import LoadingSpinner from '../LoadingSpinner';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Utils from '../../Utils';

@inject('issueStore')
@observer
export default class IssueList extends React.Component {
    componentDidMount(){
        this.props.issueStore.GetIssues();
    }
    dateFormater(cell,row){
        return Utils.Dates.ToString("dd/mm/yyyy",cell);
    }
   render(){
      if(!this.props.issueStore.LoadingIssues){
        return(<BootstrapTable data={this.props.issueStore.Issues} striped={true} hover={true}>
        <TableHeaderColumn dataField="IssueId" isKey={true} hidden >IssueId</TableHeaderColumn>
        <TableHeaderColumn dataField="IssueName" dataSort={true}  >Name</TableHeaderColumn>
        <TableHeaderColumn dataField="IssueDesc" >Desc</TableHeaderColumn>
        <TableHeaderColumn dataField="IssuePriority" dataSort={true} >Priority</TableHeaderColumn>
        <TableHeaderColumn dataField="CreatedDate" dataFormat={this.dateFormater} dataSort={true} >CreatedOn</TableHeaderColumn>
    </BootstrapTable>);
      }
      else{
        return(<LoadingSpinner/>);
      }
   }
}


// WEBPACK FOOTER //
// ./src/components/Issues/IssueList.js